import { render } from "./DrugstoreOrGroupsTabsModal.vue?vue&type=template&id=93449e78&scoped=true"
import script from "./DrugstoreOrGroupsTabsModal.vue?vue&type=script&lang=js"
export * from "./DrugstoreOrGroupsTabsModal.vue?vue&type=script&lang=js"

import "./DrugstoreOrGroupsTabsModal.vue?vue&type=style&index=0&id=93449e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93449e78"]])

export default __exports__